import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./index.css";
import ICONS from "../../../../../assets/Icons";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import FormatAmount from "../../../../../components/_utils/FormatAmount/FormatAmount";

const ScheduleBeneficiaryMultiApprovalSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [successPageID, setsuccessPageID] = useState([]);
  const [successPageData, setsuccessPageData] = useState([]);
  const [pendingTransactions, setPendingTransactions] = useState([]);
  const [approvedTransactions, setApprovedTransactions] = useState([]);

  const goToDashboard = () => {
    navigate("/beneficiary_transaction_dashboard");
  };

  const approveMoreSchedules = () => {
    navigate("/beneficiary_transaction_dashboard/schedule_multi_approval");
  };

  const buttonRows = [
    [
      {
        btnText: "Approve more schedules",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.APPROVE_MORE_TXN,
        imgColor: "var(--positive-bg)",
        handleFunction: approveMoreSchedules,
        fullWidthRequired: true,
        hoverOption: "dark",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: goToDashboard,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));
    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    const storedSelectedApproval = JSON.parse(
      sessionStorage.getItem("selectedscheduleData"),
    );

    if (storedSelectedApproval) {
      const transactions =
        storedSelectedApproval?.selectedSendTransactions || [];

      const pending = transactions.filter(
        (transaction) => transaction.lifecycle_status === "pending",
      );
      const approved = transactions.filter(
        (transaction) => transaction.lifecycle_status === "approved",
      );
      setsuccessPageData(storedSelectedApproval?.selectedSendTransactions);
      setPendingTransactions(pending);
      setApprovedTransactions(approved);
      setsuccessPageID(storedSelectedApproval.selectedTransactions);
    } else {
      setsuccessPageData([]);
      setsuccessPageID([]);
    }
  }, []);

  return (
    <>
      <StatusContainer
        status="success"
        title={
          successPageData.length && "Schedules have been approved successfully."
        }
        buttonRows={buttonRows}
      >
        {successPageData.length > 0 && (
          <TabsWeapperSection
            title={`Approved schedules - ${successPageID.length}`}
          >
            <div className="flex flex-col">
              {successPageData.map((account, i) => (
                <InfoCard
                  key={i}
                  bgColor="var(--positive-card)"
                  hoverable="dark"
                  onClick={() =>
                    navigate(
                      `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${account?.txn_id}`,
                    )
                  }
                  rows={[
                    {
                      leftTitle: account?.scheduled_name
                        ?.toLowerCase()
                        .split(" ")
                        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
                        .join(" "),
                      leftSubTitle: "Schedule name",
                      rightTitleTextColor: "var(--text-primary)",
                      rightTextFontWeight: "semibold",
                      hasRight: true,
                      rightIcon: true,
                      rightText: true,
                      rightTitle: `INR ${FormatAmount({ price: account?.amount })}`,
                      rightSubTitle: "Amount",
                      onClick: () =>
                        navigate(
                          `/beneficiary_transaction_dashboard/schedule_view_all/schedule_detail_page/${account?.txn_id}`,
                        ),
                    },
                  ]}
                />
              ))}
            </div>
          </TabsWeapperSection>
        )}
      </StatusContainer>
    </>
  );
};

export default ScheduleBeneficiaryMultiApprovalSuccess;
